import styled from 'styled-components'
import { useGeneralContext } from './contexts/GeneralContext'
import { sortByProperty } from './utils/sortByProperyty'
import { Redirect, useHistory } from 'react-router-dom'
import { navDirections } from './utils/navDirections'
import { useAuthContext } from './contexts/AuthContext'
import { chapters, subjectColors, subjectNames } from './utils/chapter'

function OnlineClassSubjects() {
    const { subSelected, setChapterSelected } = useGeneralContext()
    const { userDetails } = useAuthContext()

    const history = useHistory()

    const onChapterSelection = (chapter) => {
        setChapterSelected(chapter)
        history.push(navDirections.ONLINE_CLASS_CHAPTERS)
    }

    return (
        (!!subSelected && (
            <ChapterContainer>
                <Heading>{subjectNames[subSelected]}</Heading>

                {chapters[
                    userDetails?.batch?.grade === 'plusOne'
                        ? 'plusOneChapters'
                        : 'plusTwoChapters'
                ][subSelected]

                    .sort(sortByProperty('chapterNo'))
                    .map((sub, index) => (
                        <ChapterListItem
                            key={index}
                            onClick={() => onChapterSelection(sub.chapterName)}
                        >
                            <ChapterNumber subSelected={subSelected}>
                                {sub.chapterNo < 10
                                    ? `0${sub.chapterNo}`
                                    : sub.chapterNo}
                            </ChapterNumber>
                            <ChapterName>{sub.chapterName}</ChapterName>
                        </ChapterListItem>
                    ))}
            </ChapterContainer>
        )) || <Redirect to={navDirections.HOME} />
    )
}

const ChapterContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 100px;
`
const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const ChapterListItem = styled.div`
    background: #363862;
    margin: 15px auto;
    width: 100%;
    max-width: 450px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 5px;
    cursor: pointer;
    transition: transform ease-in-out 0.2s;
    position: relative;
    padding-left: 50px;

    &:hover {
        transform: scale(1.02);
    }
    &:active {
        transform: scale(0.98);
    }
`
const ChapterNumber = styled.p`
    clip-path: polygon(0 0, 100% 0, 65% 100%, 0% 100%);
    background: ${({ subSelected }) => subjectColors[subSelected]};

    color: #fff;
    padding: 10px;
    width: 50px;
    font-weight: 600;
    border-radius: 5px 0 0 5px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
`

const ChapterName = styled.p`
    padding: 15px;
    font-weight: 500;
    color: #dcdbdb;
`

export default OnlineClassSubjects
